import React, { FC, useContext, useEffect, useState } from "react";
import ReportItem from "./ReportItem";
import Pagination from "../../../components/pagination/Pagination";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import Timofey from "../../../assets/images/Timofey_avatar.png";
import { Context } from "../../..";

interface IUserReports {
  value: string;
  data: any;
}

const UserReports: FC<IUserReports> = ({ data }) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 5; // Set the number of items to display per page
  const { users, store, roles } = useContext(Context);

  // Calculate the index range for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  const [currentPageData, setCurrentPageData] = useState(data?.selectedUser?.propertyReport?.slice(startIndex, endIndex) || [])
  const userId = data?.selectedUser?._id

  useEffect(() => {
    setCurrentPageData(data?.selectedUser?.propertyReport?.slice(startIndex, endIndex))
  }, [
    data?.selectedUser?.propertyReport
  ])

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "control")?.children?.find((child: any) => child.path === "users")
    setAdminPermissionData(userData)
  };

  useEffect(() => {
    loadNewData()
  }, [])

  return (
    <section className="section">
      <div className="section-title">
        <span>User property reports</span>
        <Pagination
          totalItems={data?.selectedUser?.propertyReport?.length}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      </div>
      <div className="section-main">
        {currentPageData?.length > 0 ? (
          currentPageData.map((report: any) => (
            <ReportItem key={report._id} data={report} handleReport={data} userId={userId} 
            actionData={adminPermissionData}
            />
          ))
        ) : (
          <div><Emptiness icon={Timofey} content="There are no User property reports" /></div>
        )}
      </div>
    </section>
  );
};

export default UserReports;
